'use client';
import React from 'react';
import { IDataFrameSchema } from '@/lib/dataFrameTypes';

import FieldList from '../FieldList';
import * as Styled from './styled';

const SchemaRail: React.FC<{
  schema: IDataFrameSchema;
  extractedFields: string[];
}> = ({ schema, extractedFields, ...rest }) => {
  return (
    <Styled.SchemaRail {...rest}>
      <b>Available fields</b>
      <div>
        <Styled.FieldListContainer>
          <FieldList schema={schema as IDataFrameSchema} activeFields={extractedFields} className="field-list" />
        </Styled.FieldListContainer>
      </div>
    </Styled.SchemaRail>
  );
};

export default SchemaRail;
